import { render, staticRenderFns } from "./showWindowAdmin.vue?vue&type=template&id=6663ea13"
import script from "./showWindowAdmin.vue?vue&type=script&lang=js"
export * from "./showWindowAdmin.vue?vue&type=script&lang=js"
import style0 from "./showWindowAdmin.vue?vue&type=style&index=0&id=6663ea13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports